import { render } from "./AgentRequests.vue?vue&type=template&id=803d6f5c&scoped=true"
import script from "./AgentRequests.vue?vue&type=script&lang=js"
export * from "./AgentRequests.vue?vue&type=script&lang=js"

import "./AgentRequests.vue?vue&type=style&index=0&id=803d6f5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803d6f5c"]])

export default __exports__